// extracted by mini-css-extract-plugin
module.exports = {"toggle":"theme-module--toggle--HBCYm","toggled":"theme-module--toggled--W7czZ"};